import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dashboardIcon from '../../Assest/img/dashboardIcon (1).svg';
import inquiryIcon from '../../Assest/img/inquiryIcon.svg';
import interestedVendorIcon from '../../Assest/img/interestedVendorIcon.svg';
import dashbordActiveIcon from '../../Assest/img/dashboardActiveicon.svg';
import inquiryActiveIcon from '../../Assest/img/inquiryActiveIcon.svg';
import interestedVendorActiveIcon from '../../Assest/img/interestedVendorActiveIcon.svg';
import { sidebarAction } from "../../ReduxStore/sideBarState";
import { Link, useNavigate, useLocation } from "react-router-dom";

function Sidebar() {
    const activeTab = useSelector((state) => state.sidebar.activeTab);
    const [hovered, setHovered] = useState([false, false, false]);
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Toggle sidebar visibility on mobile
    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
    };

    // Close sidebar when clicking outside on mobile

        
        const handleActiveTab = (e, tab, route) => {
            e.preventDefault();
            dispatch(sidebarAction.selectActiveTab(tab));
            navigate(route);
            if (window.innerWidth <= 768) {
            setIsSidebarVisible(false);
        }
    };

    const handleMouseEnter = (index) => {
        setHovered(hovered.map((_, i) => i === index));
    };

    const handleMouseLeave = () => {
        setHovered([false, false, false]);
    };

    return (
        <>
            {/* Mobile Menu Button */}
            <button 
                className="md:hidden fixed top-[0.9375rem] left-[1rem] z-50 p-2"
                onClick={toggleSidebar}
            >
                <svg className="w-[1.5rem] h-[1.5rem]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>

            <aside 
                id="sidebar" 
                className={`sidebar ${isSidebarVisible ? 'visible' : ''}`}
            >
                <ul className="sidebar-nav" id="sidebar-nav">
                    {/* Dashboard */}
                    <li
                        className={`nav-item flex items-center p-3 my-2 rounded-lg cursor-pointer 
                            ${(hovered[0] || activeTab === 'dashboard') ? 'bg-[#600AAD] text-white' : 'text-[#600AAD]'}`}
                        onClick={(e) => handleActiveTab(e, 'dashboard', '/dashboard')}
                        onMouseEnter={() => handleMouseEnter(0)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <img
                            src={(hovered[0] || activeTab === 'dashboard') ? dashbordActiveIcon : dashboardIcon}
                            alt="dashboard icon"
                            className="w-[1.25rem] h-[1.25rem] mr-3"
                        />
                        <span className="text-base font-medium">Dashboard</span>
                    </li>

                    {/* INQUIRY */}
                    {/* <li
                        className={`nav-item flex items-center p-3 my-2 rounded-lg cursor-pointer 
                            ${(hovered[1] || activeTab === 'inquiry') ? 'bg-[#600AAD] text-white' : 'text-[#600AAD]'}`}
                        onClick={(e) => handleActiveTab(e, 'inquiry', '/inquiry')}
                        onMouseEnter={() => handleMouseEnter(1)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <img
                            src={(hovered[1] || activeTab === 'inquiry') ? inquiryActiveIcon : inquiryIcon}
                            alt="inquiry icon"
                            className="w-[1.25rem] h-[1.25rem] mr-3"
                        />
                        <span className="text-base font-medium">Inquiry</span>
                    </li> */}

                    {/* Interested Vendor */}
                    <li
                        className={`nav-item flex items-center p-3 my-2 rounded-lg cursor-pointer 
                            ${(hovered[2] || activeTab === 'interestedVendor') ? 'bg-[#600AAD] text-white' : 'text-[#600AAD]'}`}
                        onClick={(e) => handleActiveTab(e, 'interestedVendor', '/interestedVendor')}
                        onMouseEnter={() => handleMouseEnter(2)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <img
                            src={(hovered[2] || activeTab === 'interestedVendor') ? interestedVendorActiveIcon : interestedVendorIcon}
                            alt="interestedVendor icon"
                            className="w-[1.25rem] h-[1.25rem] mr-3"
                        />
                        <span className="text-base font-medium">Interested Vendor</span>
                    </li>
                </ul>
            </aside>
        </>
    );
}

export default Sidebar;
